import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { storefrontAdminAccessControl } from '../access-control/storefrontAdminAccess.configuration'
import { cartAssistantSessionDrilldownAccessControl } from '../access-control/cartAssistantSessionDrilldownAccess.configuration'

const StorefrontAdminCartAssistantSessionDrilldownPage = lazy(
  () =>
    import(
      /* webpackChunkName: "StorefrontAdminCartAssistantSessionDrilldownPage" */
      '../pages/cart-assistant-session-drilldown/StorefrontAdminCartAssistantSessionDrilldownPage'
    )
)

export const storefrontAdminCartAssistantRouter = (
  <DomainRoute route="storefront-admin-cart-assistant" accessControl={storefrontAdminAccessControl}>
    <DashSwitch>
      <DomainRoute
        exact
        route="storefront-admin-cart-assistant-session-drilldown"
        component={StorefrontAdminCartAssistantSessionDrilldownPage}
        accessControl={cartAssistantSessionDrilldownAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
